const riot = require('riot');
riot.tag2('raw', '<span></span>', '', '', function(opts) {
        this.root.innerHTML = opts.html
        this.on('update',function() {
          this.root.innerHTML = opts.html
        })
});
